// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__2zCVm","pdf":"styles_pdf__3c_Tt"};